import { Injectable } from '@angular/core';
import { SecureStoreService } from '@core/services/core/storage/secure.service';

@Injectable({
  providedIn: 'root'
})
export class FirstRunHelperService {

  private firstAppRun: boolean;

  constructor(
    private secureStore: SecureStoreService,
  ) {}

  async isFirstAppRun() {
  if (this.firstAppRun == null) {
    await this.secureStore.getNotSecure<boolean>('FIRST_APP_RUN').then(firstRun => {
      this.firstAppRun = firstRun == null ? true : firstRun;
    });
  }
    return this.firstAppRun;
  }

  async updateFirstAppRun() {
    return this.secureStore.saveNotSecure('FIRST_APP_RUN', false);
  }

}
